// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileNumber-module__mobile_input_container {
  margin: 0;
}

.MobileNumber-module__input_group {
  display: flex;
  border: 2px solid #c1c1c1;
  border-radius: 10px;
  overflow: hidden;
  align-items: center;
  padding: 6px 10px;
  background-color: #fff;
  width: fit-content;
}

.MobileNumber-module__mobile_number_input {
  border: none;
  font-size: 18px;
  font-weight: 500;
  color: #383f47;
  outline: none;
}

.MobileNumber-module__mobile_number_input::placeholder {
  font-size: 14px;
  font-weight: 400;
  color: #7d7d7d;
}

.MobileNumber-module__dial_code_select {
  font-size: 14px;
  color: #7d7d7d;
  background-color: #f8f9fa;
  margin-right: 10px;
  outline: none;
  border: none;
}

.MobileNumber-module__btn_primary {
  width: 120.52980041503906px;
  height: 50.375px;
  opacity: 1;
  font-size: 18px;
  padding: 10px;
  opacity: 1;
  border-radius: 2px;
  background-color: #fbd323;
  border-radius: 10px;
  border: none;
  color: #000000;
  font-family: Montserrat;
  font-weight: 700;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 1%;
  cursor: pointer;
}

.MobileNumber-module__btn_primary:disabled {
  background-color: #c4c4c4;
  color: #fff;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/mobilenumber/MobileNumber.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB","sourcesContent":[".mobile_input_container {\n  margin: 0;\n}\n\n.input_group {\n  display: flex;\n  border: 2px solid #c1c1c1;\n  border-radius: 10px;\n  overflow: hidden;\n  align-items: center;\n  padding: 6px 10px;\n  background-color: #fff;\n  width: fit-content;\n}\n\n.mobile_number_input {\n  border: none;\n  font-size: 18px;\n  font-weight: 500;\n  color: #383f47;\n  outline: none;\n}\n\n.mobile_number_input::placeholder {\n  font-size: 14px;\n  font-weight: 400;\n  color: #7d7d7d;\n}\n\n.dial_code_select {\n  font-size: 14px;\n  color: #7d7d7d;\n  background-color: #f8f9fa;\n  margin-right: 10px;\n  outline: none;\n  border: none;\n}\n\n.btn_primary {\n  width: 120.52980041503906px;\n  height: 50.375px;\n  opacity: 1;\n  font-size: 18px;\n  padding: 10px;\n  opacity: 1;\n  border-radius: 2px;\n  background-color: #fbd323;\n  border-radius: 10px;\n  border: none;\n  color: #000000;\n  font-family: Montserrat;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 100%;\n  letter-spacing: 1%;\n  cursor: pointer;\n}\n\n.btn_primary:disabled {\n  background-color: #c4c4c4;\n  color: #fff;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobile_input_container": `MobileNumber-module__mobile_input_container`,
	"input_group": `MobileNumber-module__input_group`,
	"mobile_number_input": `MobileNumber-module__mobile_number_input`,
	"dial_code_select": `MobileNumber-module__dial_code_select`,
	"btn_primary": `MobileNumber-module__btn_primary`
};
export default ___CSS_LOADER_EXPORT___;
